import type { PoweredBy } from '@/types/sponsor';
import { ROOBET_URL, THUNDERPICK_URL } from './bookmakers';

export const ROOBET_SPONSOR: PoweredBy = {
  name: 'Roobet',
  url: ROOBET_URL,
  logo: {
    url: '/rewards/sponsors/roobet.svg',
    width: 120,
    height: 40,
  },
};

export const THUNDERPICK_SPONSOR: PoweredBy = {
  name: 'Thunderpick',
  url: THUNDERPICK_URL,
  logo: {
    url: '/rewards/sponsors/thunderpick.png',
    width: 486,
    height: 90,
  },
};

export const PICKEMS_SPONSOR = THUNDERPICK_SPONSOR;
